import { useContext, useEffect, useState } from 'react';
import { Theme_context } from '../context/theme-context';
import img_1 from '../images/icon-moon.svg';
import img_2 from '../images/icon-sun.svg';
import themeStoragre from '../functions/themeStoragre';
export default function Changetheme() {
    let theme = useContext(Theme_context);
    let body = document.body;
    let [local_theme,setLocaltheme] = useState();
    useEffect(_ => {
      if(theme.theme == 'light') {
        body.style.backgroundColor = '#fff';
        themeStoragre('light');
      }else if(theme.theme == 'dark') {
        body.style.backgroundColor = '#181824';
        themeStoragre('dark');
      }
    },[theme])

    return (
      
    <img src={`${theme.theme === 'light' ? img_1 : img_2}`} onClick={_ => theme.theme === 'light' ? theme.setTheme('dark') : theme.setTheme('light')} className='changer_theme' alt='img-1'/>
  )
}
